import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import usePrevious from '../../../../utils/usePrevious';
import { useElementDimensions } from '../../../../utils/useElementDimensions';
import _ from 'lodash';

import { TreeSelect, Input, Divider, Row, Col, Checkbox, Button, Popconfirm, message, Spin } from 'antd';
import { SearchOutlined, CloseOutlined, CaretDownOutlined } from '@ant-design/icons';
import './TreeSelectDropdown.css';

import commonConfig from '../../../commonConfig.json';
import * as actions from '../../../../store/actions/indexes';

const { SHOW_PARENT, SHOW_CHILD } = TreeSelect;
const { Search } = Input;

let dropDownConfigs = commonConfig.dropdownProps;
let modalConfigs = commonConfig.modalProps;

const TreeSelectDropdown = props => {
    const [allTreeData, setAllTreeData] = useState([]);
    const [currentTreeData, setCurrentTreeData] = useState([]);
    const [expandedTreeKeys, setExpandedTreeKeys] = useState([]);
    const [initSelectedData, setInitSelectedData] = useState([]);
    const [selectedData, setSelectedData] = useState([]);
    const [allSelected, setAllSelected] = useState(false);
    const [disableClearAll, setDisableClearAll] = useState(false);
    const [disableApply, setDisableApply] = useState(false);
    const [currentSearchVal, setCurrentSearchVal] = useState("");
    const [drpdwnOpen, setDrpdwnOpen] = useState(false);
    const [dataApplied, setDataApplied] = useState(false);
    const [backspaceClick, setBackspaceClick] = useState(false);
    const [pendingLoader, setPendingLoader] = useState(false);

    const dispatch = useDispatch();

    const prevSelectedData = usePrevious(selectedData);
    const updatedGroupingData = useSelector((state) => state.groupingModalReducer.submissionResponse, shallowEqual);
    const isControlledFiltersOpen = useSelector((state) => state.controlledComponentsReducer.isControlledFiltersOpen, shallowEqual);
    const [{ width }, eleRef]  = useElementDimensions();
    
    const treeSelectRef = useRef({
        groupingEditDelClicked: false,
        groupingActionType: '',
        groupingEditDelClickedData: {
            userGroupId: '',
            groupId: ''
        }
    });
    const getAllKeys = data => {
        const nestedKeys = data.map(node => {
            let childKeys = [];
            if (node.children) {
                childKeys = getAllKeys(node.children);
            }
            return [childKeys, node.key];
        });
        return _.flattenDeep(nestedKeys);
    };

    const setGlobalLevelControlledFiltersOpenClose = (e) => {
        let copyOfFilterStates = JSON.parse(JSON.stringify(isControlledFiltersOpen));
        for (const key in copyOfFilterStates) {
            if (e === true) {
                if (key === props.indexName) {
                    copyOfFilterStates[key] = e
                } else {
                    copyOfFilterStates[key] = false
                }
            } else {
                if (key === props.indexName) {
                    copyOfFilterStates[key] = e;
                    break;
                }
            }
        }
        dispatch(actions.setControlledFiltersOpen(copyOfFilterStates));
        return;
    }

    const onKeyDown = (e) => {
        if (e.keyCode == 8) {
            e.stopPropagation();
            setBackspaceClick(true);
        }
        return;
    }
    const onChange = (value, label, extra) => {
        let newValue = [];
        // console.log(value, "value", label, "label", extra, "extra", "onchange treeselect");
        if (!drpdwnOpen) {
            if (props.apply === dropDownConfigs.apply.ONAPPLY) {
                setGlobalLevelControlledFiltersOpenClose(true);
                setDrpdwnOpen(true);
            } else if (props.apply === dropDownConfigs.apply.ONCHANGE) { // if prop.apply is onchange - do search data update direct without any apply btn
                setDataApplied(true);
                if (_.has(JSON.parse(extra.triggerValue), 'groupId') ||
                    (_.isArray(JSON.parse(extra.triggerValue)) &&
                        JSON.parse(extra.triggerValue)[0] !== undefined &&
                        _.has(JSON.parse(JSON.parse(extra.triggerValue)[0]), 'groupId')
                    )
                ) {
                    // if grouping related selected - remove non-group related items from value if exists
                    newValue = _.filter(value, (ele) => {
                        return _.has(JSON.parse(ele), 'groupId')
                    })
                } else {
                    // if non-grouping related selected - remove grouping related items from value if exists
                    newValue = _.sortBy(
                        _.filter(value, (ele) => {
                            return !_.has(JSON.parse(ele), 'groupId')
                        }),
                        (o => JSON.parse(o).index)
                    )
                }
                // console.log(selectedData, "selectedData", newValue, "newValue", "at onchange");
                setSelectedData(newValue);
                return;
            }
        }
        if (!treeSelectRef.current.groupingEditDelClicked) {
            if (!backspaceClick) {
                if (_.has(JSON.parse(extra.triggerValue), 'groupId') ||
                    (_.isArray(JSON.parse(extra.triggerValue)) &&
                        JSON.parse(extra.triggerValue)[0] !== undefined &&
                        _.has(JSON.parse(JSON.parse(extra.triggerValue)[0]), 'groupId')
                    )
                ) {
                    // if grouping related selected - remove non-group related items from value if exists
                    newValue = _.filter(value, (ele) => {
                        return _.has(JSON.parse(ele), 'groupId')
                    })
                } else {
                    // if non-grouping related selected - remove grouping related items from value if exists
                    newValue = _.sortBy(
                        _.filter(value, (ele) => {
                            return !_.has(JSON.parse(ele), 'groupId')
                        }),
                        (o => JSON.parse(o).index)
                    )
                }
                // console.log(selectedData, "selectedData", newValue, "newValue", "at onchange");
                setSelectedData(newValue);
            } else {
                setBackspaceClick(false);
            }
        } else {
            if (treeSelectRef.current.groupingActionType !== "DELETE") {
                treeSelectRef.current.groupingEditDelClicked = false;
                treeSelectRef.current.groupingActionType = "";
                treeSelectRef.current.groupingEditDelClickedData.userGroupId = "";
                treeSelectRef.current.groupingEditDelClickedData.groupId = "";
            }
        }


        return;
    }

    const onCheckSelectAll = (e) => {
        // console.log(e, "e on onCheckSelectAll");
        if (e.target.checked) { //if checked - set selectedData to all values in currentTreeData
            let selected = currentTreeData.map(s => s.value);
            setSelectedData(selected);
        } else { //if unchecked - set selectedData to empty array
            setSelectedData([]);
        }
        return;
    }

    const onClickClearAll = (e) => {
        setSelectedData([]);
        return;
    }

    const onDrpDwnOpenClose = (e) => {
        // console.log(e ,"e on onDrpDwnOpenClose");
        if (e) { // if true
            if (props.apply === dropDownConfigs.apply.ONAPPLY) {
                setGlobalLevelControlledFiltersOpenClose(e);
            }
            setDataApplied(false);
            setDrpdwnOpen(e);
        }
        return;
    }

    const handleSearch = (e) => {
        e.preventDefault();
        let val = e.target.value;
        let searchRes = [];
        // console.log(val, "val of handleSearch");
        if (val) {
            if (props.grouping) {
                searchRes = allTreeData.map(ele => {
                    var child = _.filter(ele.children, (element) => {
                        return _.includes(element.title.toLowerCase(), val.toLowerCase())
                    });
                    return {
                        title: ele.title,
                        className: ele.className,
                        value: ele.value,
                        children: child,
                        disabled: (child.length === 0) ? true : false
                    }
                });
            } else {
                searchRes = _.filter(allTreeData, (element) => {
                    return _.includes(element.title.toLowerCase(), val.toLowerCase())
                });
            }
            setCurrentTreeData(searchRes);
        } else {
            setCurrentTreeData(allTreeData);
        }
        setCurrentSearchVal(val);
        return;
    }

    const onClickApply = () => {
        setGlobalLevelControlledFiltersOpenClose(false);
        setDataApplied(true);
        setDrpdwnOpen(false);
        let additionalData = "";
        props.callback({
            key: props.indexName,
            selectedOption: selectedData,
            valuesType: props.indexValType,
            type: props.indexType,
            indexCategory: props.indexCategory,
            additionalData: additionalData,
            actualApply: true
        });
        return;
    }

    const onClickCancel = () => {
        setGlobalLevelControlledFiltersOpenClose(false)
        setDrpdwnOpen(false)
        return;
    }
    useEffect(() => {
        let newOptions = [];
        if (props.grouping && 
            _.some(props.groupingMode, (m) => {
                return [dropDownConfigs.groupingMode.EDIT,dropDownConfigs.groupingMode.DELETE].includes(m)
            }) === true) {
            newOptions = JSON.parse(JSON.stringify(props.options));
            let tempOptions = JSON.parse(JSON.stringify(props.options));
            let tempGrouping = tempOptions.filter(f => f.className.split("_").slice(-1)[0] === "grouping");
            let groupingChildren = tempGrouping[0].children.map(grp => {
                return {
                    title: grp.title,
                    value: grp.value,
                    key: grp.key,
                    label: (
                        <span>
                            <span id='groupingOptionsTitle'>
                                {grp.title}
                            </span>
                            <span id='groupingOptionsBtnSection'>
                                <Button
                                    type='link'
                                    className='treedropdown_linkbtneditGrp'
                                    disabled={(props.groupingMode.includes(dropDownConfigs.groupingMode.EDIT)) ? false : true}
                                    onClick={() => {
                                        treeSelectRef.current.groupingEditDelClicked = true;
                                        treeSelectRef.current.groupingActionType = "EDIT";
                                        setDrpdwnOpen(false);
                                        setGlobalLevelControlledFiltersOpenClose(false);
                                        if (grp.value !== undefined) {
                                            let JVal = JSON.parse(grp.value);
                                            treeSelectRef.current.groupingEditDelClickedData.userGroupId = JVal.userGroupId;
                                            treeSelectRef.current.groupingEditDelClickedData.groupId = JVal.groupId;
                                            dispatch(actions.callGroupingModal(
                                                modalConfigs.modalType.FILTER_SEC_GROUPING,
                                                'EDIT',
                                                JVal.groupId.toString(),
                                                JVal.userGroupId.toString(),
                                                props.indexName,
                                                props.indexValType
                                            )
                                            );
                                        }
                                    }}
                                >
                                    Edit
                                </Button>
                                <span className="groupingOptionsBtnSeperator">|</span>
                                <Popconfirm
                                    title="Are you sure you want to delete this group?"
                                    onConfirm={() => {
                                        treeSelectRef.current.groupingEditDelClicked = true;
                                        treeSelectRef.current.groupingActionType = "DELETE";
                                        // setDrpdwnOpen(false)
                                        if (grp.value !== undefined) {
                                            let JVal = JSON.parse(grp.value);
                                            treeSelectRef.current.groupingEditDelClickedData.userGroupId = JVal.userGroupId;
                                            treeSelectRef.current.groupingEditDelClickedData.groupId = JVal.groupId;
                                            setPendingLoader(true);
                                            dispatch(actions.deleteGroup({
                                                "userGroupId": JVal.userGroupId,
                                                "groupId": JVal.groupId,
                                                "userName": JVal.userName,
                                                "entityId": JVal.entityId,
                                                "projectId": JVal.projectId
                                            }));
                                        }
                                        // this.deleteGroup(group)
                                    }}
                                    onCancel={() => {
                                        treeSelectRef.current.groupingEditDelClicked = true;
                                        treeSelectRef.current.groupingActionType = "";
                                        // setDrpdwnOpen(false)
                                    }}
                                    okButtonProps={{
                                        type: "default",
                                        danger: true
                                    }}
                                    okText="Delete"
                                    cancelButtonProps={{
                                        type: "default"
                                    }}
                                    cancelText="Cancel"
                                >
                                    <Button
                                        type='link'
                                        className='treedropdown_linkbtndeleteGrp'
                                        disabled={(props.groupingMode.includes(dropDownConfigs.groupingMode.DELETE)) ? false : true}
                                        onClick={() => {
                                            treeSelectRef.current.groupingEditDelClicked = true;
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </Popconfirm>
                            </span>
                        </span>
                    )
                }
            })

            tempGrouping[0].children = groupingChildren;
            let fIndex = _.findIndex(tempOptions, (e => e.className.split("_").slice(-1)[0] === "grouping"));
            newOptions[fIndex] = tempGrouping[0];
        } else {
            newOptions = [...props.options]
        }
        setAllTreeData(newOptions);
        setCurrentTreeData(newOptions);
        //get all keys of the tree data and set it on treeselect prop treeExpandedKeys to expand the items after update
        const allOptKeys = getAllKeys(newOptions);
        setExpandedTreeKeys(allOptKeys);

        return () => {
            setAllTreeData([]);
            setCurrentTreeData([]);
        } //cleanup  
    }, [props.options]);

    useEffect(() => {
        setSelectedData(props.selectedOptions);
        setInitSelectedData(props.selectedOptions);
        setPendingLoader(false);
        return () => {
            setSelectedData([]);
            setInitSelectedData([]);
            setPendingLoader(false);
        } //cleanup  
    }, [props.selectedOptions]);

    useEffect(() => {
        if (currentTreeData.length !== 0) {
            if (selectedData.length === 0) {
                setDisableApply(true);
                setAllSelected(false);
                setDisableClearAll(true);
            } else {
                setDisableClearAll(false);
                if (!props.grouping) {
                    let tempfilter = _.filter(currentTreeData, (element) => {
                        return _.includes(selectedData, element.value)
                    });
                    if (currentTreeData.length === tempfilter.length) {
                        setAllSelected(true);
                    } else {
                        setAllSelected(false);
                    }
                } else {
                    setAllSelected(false);
                }

                /** Check whether initial selection is same as current selection - if same disable "Apply" btn else enable "Apply" btn */
                let comparePrevNewFilterSel = _.xor(selectedData,initSelectedData);
                if (comparePrevNewFilterSel.length === 0) {
                    setDisableApply(true);
                } else {
                    setDisableApply(false);
                }
                if (props.apply === dropDownConfigs.apply.ONCHANGE && dataApplied === true) { // if prop.apply is onchange - do search data update direct without any apply btn
                    let additionalData = "";
                    props.callback({
                        key: props.indexName,
                        selectedOption: selectedData,
                        valuesType: props.indexValType,
                        type: props.indexType,
                        indexCategory: props.indexCategory,
                        additionalData: additionalData,
                        actualApply: true
                    });
                }
            }
        } else {
            setDisableApply(true);
            setAllSelected(false);
            setDisableClearAll(true);
        }
        //   return () => {}//cleanup  
    }, [selectedData, currentTreeData, props.grouping])

    useLayoutEffect(() => {
        if (initSelectedData.length !== 0) {
            if (!drpdwnOpen) { //if drpdwn closing
                if (!dataApplied) { //if selection not applied - reset the selection to previous applied selection
                    // console.log(initSelectedData, "initSelectedData at drpdwnOpen");
                    setSelectedData(initSelectedData);
                }
                //set global variable the dropdown open/close
                setCurrentSearchVal("");
                setCurrentTreeData(allTreeData);
                setDataApplied(false);
            }

        }
    }, [drpdwnOpen])

    useEffect(() => {
        if (treeSelectRef.current.groupingEditDelClicked === true && treeSelectRef.current.groupingActionType === "DELETE") {
            if (updatedGroupingData.submissionType === "DELETE") {
                treeSelectRef.current.groupingEditDelClicked = false;
                treeSelectRef.current.groupingActionType = "";
                if (updatedGroupingData.responseType === "SUCCESS") {
                    let updatedGroupData = [];
                    updatedGroupData = updatedGroupingData.responseData.data;
                    message.success(updatedGroupingData.responseData.message);
                    props.groupingUpdateCallback(
                        props.indexName, props.indexValType, 
                        "groupedData",
                        updatedGroupData, 
                        [{userGroupId: treeSelectRef.current.groupingEditDelClickedData.userGroupId, groupId: treeSelectRef.current.groupingEditDelClickedData.groupId}],
                        "DELETE"
                    );
                } else if (updatedGroupingData.responseType === "FAIL") {
                    message.error(updatedGroupingData.responseData.message);
                    setPendingLoader(false);
                }
                treeSelectRef.current.groupingEditDelClickedData.userGroupId = "";
                treeSelectRef.current.groupingEditDelClickedData.groupId = "";
            }
        }
    }, [updatedGroupingData])

    useLayoutEffect(() => {
        if (isControlledFiltersOpen[props.indexName] !== undefined) {
            if (drpdwnOpen !== isControlledFiltersOpen[props.indexName]) {
                setDrpdwnOpen(isControlledFiltersOpen[props.indexName])
            }
        }
    }, [isControlledFiltersOpen])



    return (
        props.options.length !== 0 ?
            <Spin
                wrapperClassName="dropdownTagLoader"
                spinning={pendingLoader}
            >
                <div ref={eleRef}>
                <TreeSelect
                    key={props.key}
                    className="treeSelDrpDwn"
                    placement="bottomLeft"
                    dropdownClassName='treeSelDrpDwnPopUp'
                    placeholder={props.placeholder}
                    open={isControlledFiltersOpen[props.indexName]}
                    // open={drpdwnOpen}
                    treeData={currentTreeData}
                    value={selectedData}
                    disabled={props.disabled}
                    onChange={onChange}
                    onDropdownVisibleChange={onDrpDwnOpenClose}
                    showCheckedStrategy={props.grouping ? SHOW_CHILD : SHOW_PARENT}
                    showSearch={false}
                    treeDefaultExpandAll={true}
                    treeExpandedKeys={expandedTreeKeys}
                    treeCheckable={props.mode === 'multiple' ? true : false}
                    style={{
                        width: '100%',
                        maxHeight: '32px',
                        overflowY: 'auto',
                        verticalAlign: 'bottom'
                    }}
                    switcherIcon={" "}
                    virtual={false}
                    maxTagCount={1}
                    /*31=>margins & paddings in tag (px)(both hotel name tag and count tag);
                    8.012*(decimalpoints in the no.) + (3*3.737)[3dots] + 8.012[plus] + 2*3.626[2 spaces]=> 8.012*(decimalpoints in the no.) + 26.475 =>count tag size(px);
                    28=>padding at arrow
                    9=> char/font size(px);width=>input width*/
                    maxTagTextLength={width === 0 ? 15 : (selectedData.length > 1 ? 
                        (Math.round((width -28 - ((31*2)+(((selectedData.length-1).toString().length*9)+54)+(3*3.737)))/14)) : 
                        (Math.round((width -28 - (31+(3*9)))/14)) 
                    )}
                    // maxTagTextLength={width === 0 ? 15 : (selectedData.length > 1 ? (Math.round((width - (31+89.48+(3*9)))/9)) : (Math.round((width - (31+(3*9)))/9)) )}
                    showArrow={true}
                    suffixIcon={
                        <CaretDownOutlined className="ant-select-suffix" onClick={() => setDrpdwnOpen(!drpdwnOpen)} />
                    }
                    onKeyDown={onKeyDown}
                    labelInValue={false}
                    // dropdownPopupAlign={{ overflow: { adjustY: 0, adjustX: 0 } }}
                    // dropdownAlign={{ offset: [0, 4] }}
                    // dropdownStyle={{
                    //     top: document.getElementsByClassName("treeSelDrpDwn")[0] !== undefined ? 
                    //     (document.getElementsByClassName("treeSelDrpDwn")[0].offsetTop + 4 + 131)+'px !important' :
                    //      'inherit !important' 
                    // }}
                    dropdownRender={dropdownitems => (
                        <Spin
                            wrapperClassName="dropdownLoader"
                            spinning={pendingLoader}
                        >
                            <div className='treedropdownRenderMain'>
                                <div className='treedropdownSearchSection'>
                                    {props.showSearch ? (
                                        <Search
                                            className={"treedropdown_search"}
                                            allowClear
                                            prefix={<SearchOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />}
                                            placeholder="Search"
                                            // onSearch={handleSearch}
                                            value={currentSearchVal}
                                            onChange={handleSearch}
                                            style={{ borderRadius: '4px', borderColor: '#cad3da' }}
                                        // onKeyDown={this.keyDown}
                                        />
                                    ) : ("")}
                                </div>
                                <div className='treedropdownMiddleSection'>
                                    <Row>
                                        <Col span={12} className="treedropdownMiddleSection_left">
                                            {props.grouping ? ("") : (
                                                <Checkbox
                                                    className={"treedropdown_chkSelectAll"}
                                                    // indeterminate={this.state.indeterminate}
                                                    onChange={onCheckSelectAll}
                                                    checked={allSelected}
                                                    disabled={currentTreeData.length === 0 ? true : false}
                                                >
                                                    Select all
                                                </Checkbox>
                                            )}
                                        </Col>
                                        <Col span={12} className="treedropdownMiddleSection_right">
                                            <Button
                                                type="link"
                                                className={"treedropdown_linkbtnClearAll"}
                                                onClick={onClickClearAll}
                                                disabled={disableClearAll}
                                            >
                                                <CloseOutlined style={{ verticalAlign: 'middle', marginLeft: '4px', marginTop: '-4px' }} />
                                                <span>Clear All</span>
                                            </Button>

                                            {/* <CloseOutlined style={{ padding: '0 5px' }} />
                                            <span>Clear All</span> */}


                                        </Col>
                                    </Row>
                                </div>
                                <Divider style={{ margin: '4px 0' }} />
                                {dropdownitems}
                                <Divider style={{ margin: '4px 0' }} />
                                <div className='treedropdownBottomSection'>
                                    <Row gutter={[0, 16]}>
                                        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12} className='treedropdownBottomSection_left'>
                                        {props.groupingMode.includes(dropDownConfigs.groupingMode.CREATE) ? (
                                            <Button type="link"
                                                className="treedropdown_newHotelGroupLink"
                                                // style={(this.props.availableHotels.length > 1) ? { "display": "block" } : { "display": "none" }}
                                                onClick={() => {
                                                    setDrpdwnOpen(false);
                                                    setGlobalLevelControlledFiltersOpenClose(false);
                                                    treeSelectRef.current.groupingActionType = "CREATE";
                                                    dispatch(actions.callGroupingModal(
                                                        modalConfigs.modalType.FILTER_SEC_GROUPING,
                                                        'CREATE',
                                                        '',
                                                        '',
                                                        props.indexName,
                                                        props.indexValType
                                                    )
                                                    );
                                                    // this.props.setDropdownOpen(false);
                                                    // // console.log(this.state.prevValue, this.allValues, "values...")
                                                    // var prevValue = this.state.prevValue;
                                                    // if (prevValue.length == 0) {
                                                    //     prevValue = _.map(this.state.treeDataAll, 'value')
                                                    // }
                                                    // this.setState({
                                                    //     searchVal: "",
                                                    //     treeData: this.state.treeDataAll,
                                                    //     value: prevValue,
                                                    //     isAllSelected: this.state.treeDataAll.length === prevValue.length ? true : false,
                                                    // })
                                                }}
                                            >+ New {props.indexName} Group
                                            </Button>
                                        ) : ("")}
                                        </Col>
                                        <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                            {props.apply !== dropDownConfigs.apply.ONAPPLY ? ("") : (
                                                <Row className='treedropdownBottomSection_right'>
                                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                        <Button
                                                            className={"treedropdown_btnCancel"}
                                                            type="button"
                                                            onClick={onClickCancel}
                                                        // disabled={(this.state.value.length === 0)}
                                                        >Cancel
                                                        </Button>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                        <Button
                                                            className={"treedropdown_btnApply"}
                                                            type="primary"
                                                            onClick={onClickApply}
                                                            disabled={disableApply}
                                                            // disabled={selectedData.length === 0 ? true : false}
                                                        >Apply</Button>
                                                    </Col>
                                                </Row>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Spin>
                    )}
                />
                </div>
            </Spin>
            : <></>
    )
}

export default React.memo(TreeSelectDropdown);